/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { recruiterAvailabilityUpdate } from '../../axios/recruiterAvailabilityUpdate'
import type {
	RecruiterAvailabilityUpdateError,
	RecruiterAvailabilityUpdateRequest,
	RecruiterAvailabilityUpdateResponse,
} from '../../types/RecruiterAvailabilityUpdate'

export const recruiterAvailabilityUpdateMutationKey = () => [{ url: '/interview-scheduling/availability' }] as const

export type RecruiterAvailabilityUpdateMutationKey = ReturnType<typeof recruiterAvailabilityUpdateMutationKey>

export type RecruiterAvailabilityUpdateVariables = {
	data: RecruiterAvailabilityUpdateRequest
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterAvailabilityController.php RecruiterAvailabilityController::update */
export function useRecruiterAvailabilityUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		RecruiterAvailabilityUpdateResponse,
		AxiosError<RecruiterAvailabilityUpdateError>,
		RecruiterAvailabilityUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: recruiterAvailabilityUpdateMutationKey(),
		mutationFn: ({ data }: RecruiterAvailabilityUpdateVariables) =>
			recruiterAvailabilityUpdate(data, config).then(res => res.data),
		...options,
	})
}
